import * as React from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface Props {
  interval: string;
  onChange: (interval: string) => void;
  disabledIntervals?: string[];
}

const intervalOptions = [
  { label: "1 minute", value: "1m" },
  { label: "5 minutes", value: "5m" },
  { label: "15 minutes", value: "15m" },
  { label: "1 hour", value: "1h" },
  { label: "6 hours", value: "6h" },
  { label: "1 day", value: "1d" },
  { label: "1 week", value: "1w" },
  { label: "1 month", value: "1M" }
];

const IntervalSelector: React.FC<Props> = ({ interval, onChange, disabledIntervals = [] }) => {
  const handleChange = React.useCallback(
    (event: SelectChangeEvent) => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <InputLabel id="interval-select-label">Interval</InputLabel>
      <Select
        labelId="interval-select-label"
        id="interval-select"
        value={interval}
        label="Interval"
        onChange={handleChange}
      >
        {intervalOptions.map(option => (
          <MenuItem key={option.value} value={option.value} disabled={disabledIntervals.includes(option.value)}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { IntervalSelector, intervalOptions };
